"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialPill = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var StringManipulater_1 = require("@CommonFrontend/Utils/StringManipulater");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var mobx_react_1 = require("mobx-react");
var c = (0, BemBuilder_1.default)("trial-pill-button");
exports.TrialPill = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var onClick = _a.onClick;
    var trial = (0, inversify_react_1.useInjection)("trial");
    var daysRemaining = Math.max((_b = trial.daysRemaining()) !== null && _b !== void 0 ? _b : 0, 0);
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, content: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: c("tooltip-title") }, "Free trial"),
            react_1.default.createElement("span", { className: c("tooltip-description") },
                "You have ",
                (0, StringManipulater_1.pluralise)(daysRemaining, "day"),
                " remaining on your trial. Click to upgrade when you're ready.")) },
        react_1.default.createElement("button", { className: c(), onClick: onClick },
            (0, StringManipulater_1.pluralise)(daysRemaining, "day"),
            " left")));
});
